import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { HeldStitchService } from '@modules/common/services/held-stitch.service';
import { DragNDropModule } from '@modules/drag-n-drop/drag-n-drop.module';

/**
 * The item held with Hold to Stitch, fixed at the bottom right above every app. It is a plain drag
 * source: dragging it onto anything that accepts an item drag stitches the two, so it needs no
 * target logic of its own. It sits outside every space context, so the space it drags in is the one
 * the item was held in.
 */
@Component({
  selector: 'app-held-stitch-tray',
  imports: [DragNDropModule],
  templateUrl: './held-stitch-tray.component.html',
  styleUrl: './held-stitch-tray.component.less',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeldStitchTrayComponent {
  private readonly heldStitch = inject(HeldStitchService);

  protected readonly held = this.heldStitch.held;

  protected discard(): void {
    this.heldStitch.discard();
  }
}
